import * as React from 'react';

import { App } from '../../App';
import { LayersControl, TileLayer } from 'react-leaflet';
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';

/**
 * Preconfigured LayerControl that shows three Google flavors, and
 * OpenStreetMaps. Defaults to Google Hybrid.
 */
class StandardLayerControl extends React.Component {
  render = () =>
    <LayersControl>
      <LayersControl.BaseLayer checked name="Google hybrid">
        <ReactLeafletGoogleLayer apiKey={App.mapKey} type={'hybrid'} />
      </LayersControl.BaseLayer>
      <LayersControl.BaseLayer name="Google satellite">
        <ReactLeafletGoogleLayer apiKey={App.mapKey} type={'satellite'} />
      </LayersControl.BaseLayer>
      <LayersControl.BaseLayer name="Google roadmap">
        <ReactLeafletGoogleLayer apiKey={App.mapKey} type={'roadmap'} />
      </LayersControl.BaseLayer>
      <LayersControl.BaseLayer name="OpenStreetMaps">
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />            
      </LayersControl.BaseLayer>
  </LayersControl>    
}

export { StandardLayerControl 
}